import type { AxiosError } from "axios";
import { ApiError, isApiErrorBody } from "../domain/errors/api-error";

// Erreur non liée à la session : typée quand le body suit le contrat d'erreur de l'API, laissée telle quelle sinon
// (réseau, body vide, HTML d'un proxy)
export const toApiError = (error: AxiosError): Error => {
  const body = error.response?.data;
  return isApiErrorBody(body) ? new ApiError(error.message, body) : error;
};
